import React from 'react';

import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ru from 'date-fns/locale/ru';
import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';

registerLocale('ru', ru)

const dateFormat = "dd.MM.yyyy";

export default function DatePickerInput(props) {
  const {onChange, className, ...restOfProps} = props;
  
  function onDateChange(value) {
    if (value) {
      const offset = value.getTimezoneOffset();
      value.setHours(0);
      value.setMinutes( - offset);
    }
    onChange({
      target: {
        name: props.name,
        type: 'text',
        value,
      }
    });
  }

  function handleChangeRaw({target: {value}}) {
    if (!value || value.length < 10) return;
    let newValue = value.replace(/[^0-9.]/g, '.');
    const parsedDate = parse(newValue, dateFormat, new Date());
    if (newValue !== value && isValid(parsedDate)) {
      onDateChange(parsedDate);
    }
  }
  return <DatePicker
    locale={ru}
    dateFormat={dateFormat}
    onChange={onDateChange}
    onChangeRaw={handleChangeRaw}
    className={className || "form-control datepicker"}
    placeholderText={dateFormat}
    autoComplete="off"
    disabledKeyboardNavigation={true}
    showYearDropdown
    showMonthDropdown
    dropdownMode="select"
    {...restOfProps}
  />
}